<template>
    <v-layout id="selected_properties_in_cart">
        <div>
            <!-- แสดงห้องที่ user เลือก -->
            <div v-if="current_cart&&current_cart.length>0" class="selected_properties_classic text-center">
                <div class="d-flex justify-center align-center px-0">
                    <div class="black--text" style="padding: 0 5px;font-size: 0.85em;font-weight: normal;" >
                        <v-icon small left color="black">mdi-cart</v-icon>เลือกแล้ว
                    </div>
                    <v-badge
                            v-for="(item, i) in current_cart"
                            :key="i"
                            :content="'x'"
                            :value="false"
                            color="#555"
                            overlap
                            class="col col-sm-2 col-md-2 col-lg-1 selected_properties_item_classic pa-0"
                            style="min-height: 40px;"
                    >
                        <v-icon small class="remove_item_classic" @click="removeCartItem(item)">mdi-close-circle-outline</v-icon>
                        <!--                    <div @click="scrollToDiv('properties_'+item.properties_id)">-->
                        <!--                        {{ item.pd_code }}-->
                        <!--                    </div>-->

                        <a href="javascript:void(0)"
                           @click="gotoRoute('saleOnline_propertiesDetail',{project_id:item.project_id,properties_id:item.property_id,camp:(item.hasOwnProperty('camp') ? item.camp:'')},{nextFn:[{fnName:'saveSelectedProp',data:item},{fnName:'clickSaved',data:{menu_group:'cart_toolbar',menu_name:'ข้อมูลเพิ่มเติม (ห้องที่เลือกในตะกร้า)',route_name:'saleOnline_propertiesDetail',project_id:item.project_id,property_id:item.property_id,pd_code:item.property_unit_code}}]})"
                           :class="(getProjectColor(item.project_shortname,'text_color_class') ? getProjectColor(item.project_shortname,'text_color_class'):' white--text')+'d-flex justify-center align-center d-block  selected_properties_item_a_classic'"
                           :style="'text-decoration: none;border-left:1px solid #999;background-color: '+(getProjectColor(item.project_shortname))+';font-size:0.75rem;min-height:40px;'">
                            {{ item.property_unit_code }}
                        </a>

                    </v-badge>
                    <div style="padding: 0 10px 0 0;background: #3360b1;">
                        <v-badge v-if="current_cart&&current_cart.length>0"
                                 :content="current_cart.length"
                                 :value="current_cart.length"
                                 color="red"
                                 overlap
                        >
                            <v-btn
                                    block
                                    dark
                                    color="#3360b1"
                                    class="white--text accent-2"
                                    @click="gotoRoute('saleOnline_cart',{},{nextFn:[{fnName:'clickSaved',data:{menu_group:'cart_toolbar',menu_name:'ชำระเงิน',route_name:'saleOnline_cart'}}]})"
                                    style="border-radius: 0;height: 40px;box-shadow: none;font-size: 0.75rem;"
                            >
                                ชำระเงิน
                            </v-btn>
                        </v-badge>
                    </div>
                </div>
            </div>
        </div>

    </v-layout>
</template>

<script>
    export default {
        name: "SelectedPropertiesToolBar",
        props: {
            cart_item:{type: Array, default: []},
        },
        watch:{
            cart_item(data){
                if(data) {
                    this.current_cart = [...this.cart_item]
                }else{
                    this.current_cart = []
                }

                //เปลี่ยน จำนวน notification บนปุ่ม การชำระเงิน
                // this.defaultBtmNavItem.sale_online[1].notification_count = this.current_cart ? this.current_cart.length:0
                // this.setBottomNav(true,[],'sale_online')

                //ซ่อน flash massage
                store.commit('changeFlashState',{show:false})
            }
        },
        data() {
            return {
                current_cart:this.cart_item,
                limit_cart:1,
            }
        },
        created() {
            this.$parent.reCheckCartItem()
            if(this.isEvent('PreSale')) {
                this.limit_cart = 2
            }
        },
        methods:{
            addCartItem(item){
                // console.log("do add",item)
                let old_item = this.getCartItem() ? this.getCartItem():[]
                let find_in_cart =  old_item.find(t => t.property_id === item.property_id)
                // if(old_item&&old_item.length<1) {
                if(old_item&&old_item.length<this.limit_cart) {
                    //คัดเอาเฉพาะห้องที่ยังไม่ได้เลือก
                    if(find_in_cart===undefined) {
                        old_item.push(item)
                        this.current_cart = old_item
                        localStorage.setItem(this.local_cart_key, JSON.stringify(old_item))
                    }else{
                        //ลบ ยูนิตที่เลือก ออก
                        // this.current_cart = this.removeCartItem(item)
                        this.removeCartItem(item)
                    }
                // }else if(old_item&&old_item.length>=1){
                }else if(old_item&&old_item.length>=this.limit_cart){
                    if(find_in_cart!=undefined) {
                        //ลบ ยูนิตที่เลือก ออก
                        // this.current_cart = this.removeCartItem(item)
                        this.removeCartItem(item)
                    }else {
                        store.commit('changeSnackbarState', {
                            show: true,
                            message: 'ขออภัยค่ะ ท่านสามารถเลือกจองได้ครั้งละไม่เกิน '+this.limit_cart+' ยูนิต',
                            timeout: 8000,
                            color: 'error',
                            x: '',
                            y: 'top',
                        })
                    }
                }else{
                    //กรณีเพิ่มห้องแรก
                    old_item = []
                    this.$set(old_item, 0, item)
                    this.current_cart = old_item
                    localStorage.setItem(this.local_cart_key, JSON.stringify(old_item))
                }

                return this.current_cart
            },
            async removeCartItem(item){
                if (await this.$root.$confirm.open('คำเตือน', 'คุณต้องการยกเลิกจองห้อง '+item.property_unit_code+' ใช่หรือไม่?', { color: 'red',only_agree:false })) {
                    let old_item = this.getCartItem() ? this.getCartItem():[]
                    if (old_item && old_item.length > 0) {
                        //ห้องห้องที่จะเอาออก
                        old_item = old_item.filter(t => t.property_id != item.property_id)
                    }
                    this.current_cart = old_item
                    localStorage.setItem(this.local_cart_key, JSON.stringify(old_item))
                    this.$parent.reCheckCartItem();
                }
                return this.current_cart
            },
            async removeCartItemForce(item){

                let old_item = this.getCartItem() ? this.getCartItem():[]
                if (old_item && old_item.length > 0) {
                    //ห้องห้องที่จะเอาออก
                    old_item = old_item.filter(t => t.property_id != item.property_id)
                }
                this.current_cart = old_item
                localStorage.setItem(this.local_cart_key, JSON.stringify(old_item))
                this.$parent.reCheckCartItem();

                return this.current_cart
            },
            bookNow(item) {

                let old_item = []
                this.$set(old_item, 0, item)
                this.current_cart = old_item
                localStorage.setItem(this.local_cart_key, JSON.stringify(old_item))

                this.current_cart_item = [...this.current_cart]

                this.gotoRoute('saleOnline_cart',{},{nextFn:[{fnName:'clickSaved',data:{menu_group:'booknow_button',menu_name:'ชำระเงิน',route_name:'saleOnline_cart'}}]})
            },
            scrollToDiv(elem_id){
                if(document.getElementById(elem_id)) {
                    this.$parent.scrollToDiv('#'+elem_id)
                }
            }

        }
    }
</script>

<style scoped>
    .selected_properties{
        position: fixed;
        z-index: 3;
        bottom: 56px;
        height: 40px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        background-color: #ffffff;
        box-shadow: 1px 1px 5px #555;
        left:0;
        width: 100%;
        padding: 5px 0;
        /*opacity: 0.92;*/
    }
    .selected_properties_item{
        font-size: 1rem;
        border:1px dotted #ffd752;
        margin: 1px 5px;
        background-color: #cccccc;
        border-radius: 5px;
    }
    .selected_properties_item_a:hover{
        background-color: #fff0cb;
        border-radius: 5px;
    }
    .remove_item{
        position: absolute;
        right: -8px;
        top:-8px;
        cursor: pointer;
    }
    .remove_item:hover{
        color:red;
    }

    /* classic */
    .selected_properties_classic{
        position: fixed;
        z-index: 3;
        bottom: 48px;
        height: 48px;
        background-color: rgb(242, 242, 242);
        box-shadow: 1px 1px 5px #555;
        left:0;
        width: 100%;
        padding: 0;
        /*opacity: 0.92;*/
    }

    /*.selected_properties_classic:before {*/
    /*    content: '';*/
    /*    display: block;*/
    /*    position: absolute;*/
    /*    width: 100%;*/
    /*    height: 50px;*/
    /*    top: -50px;*/
    /*    left: 0;*/
    /*    background-image: -webkit-gradient(linear, left top, left bottom, from(#e7e7e7), to(#e7e7e7));*/
    /*    background-image: linear-gradient(rgba(233, 233, 233, 0), #e7e7e7);*/
    /*}*/

    .selected_properties_item_classic{
        margin: 0;
        background-color: #cccccc;
    }
    .selected_properties_item_a_classic:hover{
        background-color: #fff0cb;
    }
    .remove_item_classic{
        color:#fff;
        position: absolute;
        right: -8px;
        top:-5px;
        cursor: pointer;
        z-index: 2;
    }
    .remove_item_classic:hover{
        color:#ccc;
    }
</style>
